import { useIsMobile } from "../../hooks/useIsMobile";
import MainLogo from "/main-logo.png";

export const NotFoundPage = () => {
  const isMobile = useIsMobile();
  return (
    <div>
      <div className="relative bg-[#0101ff] md:pb-40 pb-14">
        <div className="w-full flex items-center justify-center py-4 md:py-6 pr-[15px] 3xl:mb-32 lg:mb-12 mb-0">
          <img
            alt="Main Logo"
            src={MainLogo}
            height={isMobile ? 250 : 300}
            width={isMobile ? 250 : 300}
          />
        </div>
        {/* Wavy Line */}
        <div
          className="absolute bottom-0 w-full overflow-hidden -mb-1 pointer-events-none"
          style={{ zIndex: 0 }} // Ensure it's behind everything
        >
          <svg
            viewBox="0 0 1440 320"
            className="w-full h-auto"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill="#ffffff" // Matches bg-blue-50
              d="M0,240 C480,300 960,168 1440,240 L1440,320 L0,320 Z"
            ></path>
          </svg>
        </div>
      </div>
      <div className="flex flex-col flex-grow items-center justify-center text-center">
        <h1 className="text-4xl font-bold mt-28">Sorry, this page doesn't exist.</h1>
      </div>
    </div>
  );
};
